import React, { useEffect } from 'react';
import useComponentVisible from '../../../../hooks/useComponentVisible';
import styles from './AddTicketSelect.module.scss';

function AddTicketSelect(props) {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    const { selectedItem, disabled } = props;

    useEffect(() => {
        if (selectedItem) {
            setIsComponentVisible(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);

    return (
        <div
            className={styles.selectBox}
            disabled={disabled}
            ref={ref}
            style={{
                marginRight: props.marginRight ? `${props.marginRight}px` : '',
            }}
        >
            <div
                className={styles.selectedItem}
                disabled={disabled}
                onClick={() => {
                    !disabled && setIsComponentVisible(!isComponentVisible);
                }}
            >
                <span className={styles.itemValue}>{selectedItem}</span>
                <i className={`${styles.arrowIcon} icon-arrow-down`} />
            </div>
            {isComponentVisible && <div className={styles.selectBoxItems}>{props.children}</div>}
        </div>
    );
}

export default AddTicketSelect;
